import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

const DynamicMeta = () => {
  const { data: settings } = useQuery({
    queryKey: ['site-settings-meta'],
    queryFn: async () => {
      const { data } = await supabase.from('site_settings').select('og_image_url, seo_title_ru, seo_description_ru, favicon_url').maybeSingle();
      return data;
    },
    staleTime: 1000 * 60 * 10,
  });

  useEffect(() => {
    if (!settings) return;

    const setMeta = (property: string, content: string | null) => {
      if (!content) return;
      let el = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('property', property);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    const setMetaName = (name: string, content: string | null) => {
      if (!content) return;
      let el = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    // Update page title
    if (settings.seo_title_ru) {
      document.title = settings.seo_title_ru;
    }

    // Update favicon
    if (settings.favicon_url) {
      let link = document.querySelector('link[rel="icon"]') as HTMLLinkElement | null;
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'icon');
        document.head.appendChild(link);
      }
      link.setAttribute('href', settings.favicon_url);
      link.setAttribute('type', 'image/png');
    }

    if (settings.og_image_url) {
      setMeta('og:image', settings.og_image_url);
      setMetaName('twitter:image', settings.og_image_url);
    }
    if (settings.seo_title_ru) {
      setMeta('og:title', settings.seo_title_ru);
    }
    if (settings.seo_description_ru) {
      setMeta('og:description', settings.seo_description_ru);
      setMetaName('description', settings.seo_description_ru);
    }
  }, [settings]);

  return null;
};

export default DynamicMeta;